// removed by extract-text-webpack-plugin
module.exports = {"White":"#FFFFFF","ArrowHeight":"30px","container":"Gd38bc3","tooltip__content":"G7ca738","close":"Gb762b0"};